module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/big/package_xl.acd67d2d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/big/package_xl.png
// module id = 994
// module chunks = 16